export default defineNuxtRouteMiddleware((_to, _from) => {
  const config = useRuntimeConfig().public;
  //Criei para afins academicos para nao permitir o acesso ao perfil e fazer redirecionamento para home se a flag estiver desligada
  if (!config.featureFlagProfile) {
    return navigateTo("/");
  }
  //pelo oq vi, daria para fazer toda impletmentação por aqui... por enquanto segue oq ja foi feito de outra forma
});
